import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-svg-icon',
    templateUrl: './svg-icon.component.html',
    styleUrls: ['./svg-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class SvgIconComponent {
  constructor() {
  }

  @Input() icon: string;
  @Input() width: string;
  @Input() height: string;
  @Input() fill: string;
  @Input() fillOpacity: string;
  @Input() clickable: boolean;
  @Input() additionalClass?: string;
}
